/* Mobilicious: two delivery choices. Actual assembly lines are charged in cart.
   Shipping remains a Shopify checkout rate. No theme code runs in checkout. */
(() => {
  'use strict';
  const BASE=59230646960453, EXTRA=59230646993221;
  const services=s=>s.cart.items.filter(i=>[BASE,EXTRA].includes(Number(i.variant_id)));
  const enabled=s=>services(s).some(i=>Number(i.variant_id)===BASE && i.quantity>0);
  const savedZip=s=>String(s.cart.attributes?.['Code postal de livraison'] || s.cart.attributes?.['Code postal du montage'] || '');
  function destination(zip,s){
    zip=String(zip).trim();
    if(!/^(0[1-9]|[1-8]\d|9[0-5])\d{3}$/.test(zip))throw new Error('Indiquez votre code postal à 5 chiffres.');
    const idf=/^(75|77|78|91|92|93|94|95)\d{3}$/.test(zip);
    return {idf,shipping:idf?0:(s?.gajosOnly===true?9000:10000),zone:idf?'Île-de-France':'Hors Île-de-France'};
  }
  function quote(s,zip){
    const d=destination(zip,s);
    if(d.idf && s.packs>0)throw new Error('Pour ce pack, le premium est à confirmer avec notre équipe.');
    if(s.quantity<1 && !(s.packs>0 && !d.idf))throw new Error('Ces articles sont livrés sans montage.');
    if(s.cart.currency!=='EUR')throw new Error('Le premium est disponible pour les commandes en euros.');
    if(!s.available || s.basePrice!==7000 || s.extraPrice!==2000)throw new Error('Le premium est momentanément indisponible.');
    const extra=d.idf?Math.max(0,s.quantity-1):0;
    return {...d,extra,total:7000+extra*2000,combined:d.shipping+7000+extra*2000};
  }
  function patch(s,want,zip){
    const q=want?quote(s,zip):null,updates={};
    for(const [id,count] of [[BASE,want?1:0],[EXTRA,q?.extra||0]]){
      const rows=s.cart.items.filter(i=>Number(i.variant_id)===id);
      rows.forEach((item,index)=>{const n=index===0?count:0;if(item.quantity!==n)updates[item.key]=n;});
      if(!rows.length && count>0)updates[id]=count;
    }
    let validZip='';try{destination(zip);validZip=String(zip).trim();}catch(e){}
    const values={
      'Mode de livraison':want?'Premium — livraison + montage':'Au pas de porte',
      'Montage du mobilier':want?'Oui':'',
      'Code postal de livraison':validZip,
      'Code postal du montage':want?validZip:'',
      'Zone du montage':q?.zone||'',
      'Articles concernés par le montage':want?s.articleNames.join(' ; ').slice(0,2000):''
    },attributes={};
    for(const [k,v]of Object.entries(values))if(String(s.cart.attributes?.[k]||'')!==v)attributes[k]=v;
    return {updates,attributes};
  }
  if(typeof module==='object' && module.exports){module.exports={quote,patch,destination,enabled};return;}
  if(window.MobiAssembly)return;
  const root=window.Shopify?.routes?.root||'/',preview=new URL(location.href).searchParams.get('preview_theme_id');
  const money=n=>new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR',maximumFractionDigits:0}).format(n/100);
  const state={snapshot:null,zip:'',dirty:false,intent:null,jobs:0,chain:Promise.resolve(),error:'',timer:0,bypass:false,checkoutBusy:false,pendingCart:false};
  const panels=()=>[...document.querySelectorAll('[data-mobi-assembly-panel]')];
  const changes=p=>Object.keys(p.updates).length||Object.keys(p.attributes).length;
  function remember(value){try{value===null?sessionStorage.removeItem('mobi-premium-pending'):sessionStorage.setItem('mobi-premium-pending',String(value));}catch(e){}}
  function wanted(s){return state.intent===null?enabled(s):state.intent;}
  function text(p,selector,value){const el=p.querySelector(selector);if(el && el.textContent!==value)el.textContent=value;}
  function show(){
    const s=state.snapshot;
    for(const p of panels()){
      if(!s){text(p,'[data-delivery-status]',state.error);continue;}
      const hasFurniture=s.quantity>0||s.packs>0,hasItems=s.cart.requires_shipping===undefined?s.cart.items.some(i=>![BASE,EXTRA].includes(Number(i.variant_id))):s.cart.requires_shipping;
      p.hidden=!hasItems && !services(s).length;
      p.setAttribute('aria-busy',String(state.jobs>0));
      let d=null,q=null;try{d=destination(state.zip,s);}catch(e){}try{q=quote(s,state.zip);}catch(e){}
      const input=p.querySelector('[data-delivery-postcode]');
      if(input && document.activeElement!==input)input.value=state.zip;
      const premiumRow=p.querySelector('[data-delivery-premium-row]');if(premiumRow)premiumRow.hidden=!hasFurniture;
      const want=hasFurniture && wanted(s);
      p.querySelectorAll('[data-delivery-choice]').forEach(r=>{r.checked=(r.value==='premium')===want;r.disabled=state.jobs>0;});
      text(p,'[data-delivery-door-price]',d?(d.shipping===0?'Offerte':money(d.shipping)):'Selon adresse');
      text(p,'[data-delivery-premium-price]',q?money(q.combined):(d && d.idf && s.packs>0?'Sur devis':'Selon adresse'));
      const floor=p.querySelector('[data-delivery-floor]');if(floor)floor.hidden=!want;
      const fee=services(s).reduce((sum,i)=>sum+i.final_line_price,0);
      text(p,'[data-delivery-status]',state.error || (state.jobs?'Mise à jour…':(want && !d?'Renseignez votre code postal pour le premium.':'')));
      text(p,'[data-delivery-summary]',enabled(s)?`Montage inclus dans le panier : ${money(fee)}. Livraison au paiement.`:'Frais de livraison ajoutés au paiement.');
      const retry=p.querySelector('[data-delivery-retry]');if(retry){retry.hidden=!state.error;retry.disabled=state.jobs>0;}
    }
  }
  async function request(url,options={}){
    const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),12000);
    try{return await fetch(url,{...options,credentials:'same-origin',cache:'no-store',signal:controller.signal});}
    catch(e){throw new Error('Connexion interrompue. Réessayez avant de payer.');}
    finally{clearTimeout(timer);}
  }
  async function read(){
    const url=new URL(root,location.origin);url.searchParams.set('section_id','mobi-assembly-state');if(preview)url.searchParams.set('preview_theme_id',preview);
    const response=await request(url);if(!response.ok)throw new Error('Impossible de vérifier le panier. Réessayez.');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html'),node=doc.querySelector('[data-mobi-assembly-state]');
    if(!node)throw new Error('Impossible de charger les options. Réessayez.');
    const s=JSON.parse(node.textContent);
    if(!s.cart || !Array.isArray(s.cart.items)||!Array.isArray(s.articleNames)||!Number.isSafeInteger(s.quantity)||s.quantity<0||!Number.isSafeInteger(s.packs)||s.packs<0)throw new Error('Le panier doit être rechargé.');
    state.snapshot=s;if(!state.dirty)state.zip=savedZip(s)||String(s.defaultZip||'');return s;
  }
  async function write(s,want,zip){
    const body=patch(s,want,zip);if(!changes(body))return false;
    const response=await request(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
    const result=await response.json();if(!response.ok||result.status>=400)throw new Error('Votre choix n’a pas été enregistré. Réessayez.');
    const verified=await read();if(changes(patch(verified,want,zip)))throw new Error('Le panier a changé. Réessayez.');
    return true;
  }
  function enqueue(fn){
    state.jobs++;show();
    const task=state.chain.catch(()=>{}).then(async()=>{state.error='';try{return await fn();}catch(e){state.error=e.message;throw e;}finally{state.jobs--;show();}});
    state.chain=task;return task;
  }
  function refresh(){
    if(location.pathname.replace(/\/$/,'')===(root+'cart').replace(/\/$/,'')){
      const url=new URL(root+'cart',location.origin);if(preview)url.searchParams.set('preview_theme_id',preview);location.assign(url.href);
    }else document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{mobiAssembly:true}}));
  }
  async function reconcile(refreshPage,strict=false){
    const s=await read();if(state.pendingCart)return false;const eligible=s.quantity>0||s.packs>0;
    let want=eligible && wanted(s);
    if(!eligible){state.intent=null;remember(null);}
    if(!s.cart.items.length){show();return false;}
    if(want){try{quote(s,state.zip);}catch(e){if(strict)throw e;show();return false;}}
    const zip=state.zip,changed=await write(s,want,zip);
    state.intent=null;state.dirty=false;remember(null);
    if(changed && refreshPage)refresh();return changed;
  }
  function schedule(){clearTimeout(state.timer);state.timer=setTimeout(()=>enqueue(()=>reconcile(true)).catch(()=>{}),350);}
  function productPreference(form){
    const section=form.closest('.shopify-section');return section?.querySelector('[data-mobi-delivery-product] [data-product-delivery-choice]:checked')?.value;
  }
  document.addEventListener('submit',e=>{
    if(!e.target.matches('form'))return;
    const action=new URL(e.target.action||location.href,location.origin);
    if(/\/cart\/add\/?$/.test(action.pathname)){
      const pref=productPreference(e.target);if(pref){state.intent=pref==='premium';state.pendingCart=true;remember(state.intent);}
    }
    if(e.submitter?.name==='checkout')gateCheckout(e,()=>e.target.requestSubmit(e.submitter));
  },true);
  document.addEventListener('change',e=>{
    if(e.target.matches('[data-line-key]'))state.pendingCart=true;
    if(e.target.matches('[data-product-delivery-choice]')){
      const box=e.target.closest('[data-mobi-delivery-product]'),hint=box?.querySelector('[data-product-floor]');if(hint)hint.hidden=e.target.value!=='premium';
    }
    if(e.target.matches('[data-delivery-choice]')){
      state.intent=e.target.value==='premium';remember(state.intent);state.error='';show();
      if(state.intent){try{destination(state.zip);}catch(err){e.target.closest('[data-mobi-assembly-panel]')?.querySelector('[data-delivery-postcode]')?.focus();return;}}
      enqueue(()=>reconcile(true,true)).catch(()=>{});
    }
  },true);
  document.addEventListener('input',e=>{
    if(!e.target.matches('[data-delivery-postcode]'))return;
    state.zip=e.target.value.replace(/\s/g,'');state.dirty=true;state.error='';show();clearTimeout(state.timer);
    try{destination(state.zip);state.timer=setTimeout(()=>enqueue(()=>reconcile(true,true)).catch(()=>{}),650);}catch(err){}
  });
  document.addEventListener('keydown',e=>{if(e.target.matches('[data-delivery-postcode]')&&e.key==='Enter'){e.preventDefault();enqueue(()=>reconcile(true,true)).catch(()=>{});}});
  document.addEventListener('click',e=>{
    if(e.target.closest('[data-delivery-retry]')){e.preventDefault();enqueue(()=>reconcile(true,true)).catch(()=>{});return;}
    const a=e.target.closest('a[href]');if(!a||e.ctrlKey||e.metaKey||e.shiftKey||a.target==='_blank')return;
    const url=new URL(a.href,location.origin);if(url.origin===location.origin&&/\/(checkouts?|checkouts\/.*)\/?$/.test(url.pathname))gateCheckout(e,()=>location.assign(url.href));
  },true);
  function gateCheckout(event,proceed){
    if(state.bypass)return;event.preventDefault();event.stopImmediatePropagation();if(state.checkoutBusy)return;state.checkoutBusy=true;
    enqueue(async()=>{
      const until=Date.now()+8000;while(state.pendingCart&&Date.now()<until)await new Promise(r=>setTimeout(r,100));
      if(state.pendingCart)throw new Error('La quantité est en cours de mise à jour. Réessayez.');
      await reconcile(false,true);state.bypass=true;try{proceed();}finally{state.bypass=false;}
    }).catch(()=>{}).finally(()=>{state.checkoutBusy=false;});
  }
  for(const name of ['variant:add','cart:change','cart:refresh','cart:error'])document.addEventListener(name,e=>{if(e.detail?.mobiAssembly)return;state.pendingCart=false;schedule();});
  window.addEventListener('pageshow',e=>{if(e.persisted){state.pendingCart=false;schedule();}});
  window.MobiAssembly={quote,patch,destination,version:'2026-10-28.gajos-delivery.1'};
  function init(){
    try{const pending=sessionStorage.getItem('mobi-premium-pending');if(pending==='true'||pending==='false')state.intent=pending==='true';}catch(e){}
    const node=document.querySelector('[data-mobi-assembly-state]');if(node)try{state.snapshot=JSON.parse(node.textContent);state.zip=savedZip(state.snapshot)||String(state.snapshot.defaultZip||'');}catch(e){}
    show();enqueue(()=>reconcile(true)).catch(()=>{});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches('[data-mobi-assembly-panel]')||n.querySelector('[data-mobi-assembly-panel]'))))){show();schedule();}}).observe(document.documentElement,{childList:true,subtree:true});
})();

